import React, { useState, useEffect } from "react";
import Lottie from "react-lottie";
import animationData from "../images/lottie/form1.json";
import { connect } from "react-redux";
import { register } from "../actions/auth";
import PropTypes from "prop-types";
import { Link, Redirect, withRouter } from "react-router-dom";
import { getProblems } from "../actions/problem";

const Register = ({ register, isAuthenticated, error }) => {
  const formAnimation = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const [formData, setFormData] = useState({
    userName: "",
    email: "",
    password: "",
  });

  const { userName, email, password } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    register({ userName, email, password });
  };

  if (isAuthenticated) {
    return <Redirect to='/login' />;
  }
  return (
    <>
      <div className='container-fluid problems'>
        <div className='row'>
          <div className='col-10 mx-auto'>
            <div className='row newdetails'>
              <div className='col-md-6' data-aos='zoom-in'>
                <img
                  src={require("../images/form.svg")}
                  alt='form'
                  className='img1 hide'
                />

                <div className='animate'>
                  <Lottie options={formAnimation} height={530} width={530} />
                </div>
              </div>
              <div className='col-md-6 px-5 mt-5 col-sm-12' data-aos='fade-up'>
                <h2>Register On LearnCode</h2>
                <form onSubmit={(e) => onSubmit(e)}>
                  <input
                    type='text'
                    name='userName'
                    id='userName'
                    placeholder='User Name'
                    value={userName}
                    onChange={(e) => onChange(e)}
                    required
                  />
                  <br />
                  <input
                    type='email'
                    name='email'
                    id='email'
                    placeholder='Email'
                    value={email}
                    onChange={(e) => onChange(e)}
                    required
                  />
                  <br />
                  <input
                    type='password'
                    name='password'
                    id='password'
                    placeholder='Password'
                    value={password}
                    minLength='6'
                    onChange={(e) => onChange(e)}
                    required
                  />
                  <br />
                  <button type='submit' className='gbtn'>
                    Register
                  </button>
                  <br />
                  <button className='gbtn'>
                    <Link
                      to='/login'
                      style={{ color: "inherit", textDecorationLine: "none" }}
                    >
                      Already Registered - Login
                    </Link>
                  </button>
                  <br />
                  {error.msg === "User Already Exists" && (
                    <p className='my-2'>
                      <span style={{ color: "red" }}>{error.msg}</span>
                    </p>
                  )}
                  <p>
                    * Password Should be minimum of 6 characters and Use Unique
                    UserName
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

Register.propTypes = {
  register: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  error: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  error: state.auth.error,
});

export default connect(mapStateToProps, { register })(Register);
